import React from "react";
import { motion } from "framer-motion";
import { heroAnim, pagelineAnim } from "../../../Animation";

const FrontendHero = () => {
  return (
    <section className="main-section">
      <motion.div className="pageline-div" variants={pagelineAnim}></motion.div>
      <motion.div className="pageline-div" variants={pagelineAnim}></motion.div>
      <div className="hero">
        <div className="hero-text">
          <motion.h1 variants={heroAnim}>Front End Development</motion.h1>
          <motion.p variants={heroAnim}>
            Experienced Front-End Developer with 4+ years of building
            high-impact, responsive web applications. Skilled in
            cross-functional collaboration, clear communication, and
            consistently meeting deadlines without sacrificing quality.
            Passionate about turning ideas into polished user interfaces and
            driven by innovation to explore new technologies and best practices.
          </motion.p>
        </div>
      </div>
    </section>
  );
};

export default FrontendHero;
